import React from 'react';
import Skeleton from "@material-ui/lab/Skeleton";
import {Paper } from '@material-ui/core';
import { useSubPanelStyles } from '../styles/muiStyles';
import Avatar from '@material-ui/core/Avatar';
import SkeletonCard from './SkeletonCard';







const SkeletonHivePage = () => {
const classes = useSubPanelStyles();
  return (
    <div>
     <Skeleton variant="rect" width="60%" height={190} style={{ marginTop: 10 , marginBottom: 10 ,  width:'auto', marginLeft: 10 , marginRight: 10 , borderRadius:15,  }}  />

     <div style={{ display:'flex'}}>
     <Skeleton variant="circle" height={40} style={{ marginLeft: 10 ,marginBottom: 35 }}  >
              <Avatar />
            </Skeleton>   
     <Skeleton width="100%" height={40}  variant="rect" style={{ marginLeft: 10 , marginRight: 10 ,marginBottom: 35 , borderRadius:13 }}  />
     </div>
     <Skeleton width="60%" height={40}  variant="rect" style={{ marginBottom: 25 , width:'auto', borderRadius:13 }}  />
               
      <div style={{margin:'auto' }} >
      
      </div>
      <div style={{ marginBottom: 40 }}> </div>
      <SkeletonCard />

    </div>
  );
};


export default SkeletonHivePage;